<div class="form-layout" [formGroup]="formModel.formGroup()">
  <div class="form-side">
    <app-section [collapsible]="true" [title]="'STOCK_TYPE.STEPS.MAIN_INFO' | translate">
      <div class="input-group">
        <label sxwLabelAsterisk [inputControl]="name">{{ "STOCK_TYPE.COMMON.NAME" | translate }}</label>
        <sxw-text-input #name formControlName="name" />
      </div>

      <div class="input-group">
        <label sxwLabelAsterisk [inputControl]="code">{{ "STOCK_TYPE.COMMON.CODE" | translate }}</label>
        <sxw-text-input #code formControlName="code" />
      </div>

      <div class="input-group">
        <label>{{ "STOCK_TYPE.COMMON.DESCRIPTION" | translate }}</label>
        <sxw-text-area placeholder="COMMON.ADD_DESCRIPTION" formControlName="description"></sxw-text-area>
      </div>

      <div class="input-group">
        <label sxwLabelAsterisk [inputControl]="uploadFile">{{ "STOCK_TYPE.COMMON.FILE" | translate }}</label>
        <sxw-upload-file #uploadFile accept="image/*" [allowDrop]="!formModel.formGroup().disabled" [multiple]="false" formControlName="image">
          <ng-template #uploadButton let-disabled="disabled" let-readonly="readonly">
            <app-file-upload-design [disabled]="disabled || readonly"></app-file-upload-design>
          </ng-template>
        </sxw-upload-file>
      </div>
    </app-section>
  </div>
  <div class="actions-side">
    <app-section [title]="'COMMON.SIDE_INFO' | translate" [collapsible]="true" titleIcon="zap" titleIconStrokeColor="var(--p-gray-700)">
      <sxw-details-status formControlName="enabled" [withConfirm]="!!stockType()?.id" [useEntity]="stockType()" (confirmStatus)="onConfirm($event)" />
    </app-section>
    <app-section class="mt-10px" [title]="'COMMON.ACTIVITY_LOG.TITLE' | translate" titleIcon="activity" [collapsible]="true">
      <app-activity-log [createdAt]="stockType()?.createdAt"></app-activity-log>
    </app-section>
  </div>
</div>
